import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';
import { IStandConversationMessage } from './planograms.service';

export interface IChatUser {
	active: boolean;
	full_name: string;
	id: number;
}

export interface ILayoutConversation {
	count: number;
	next: string;
	previous: string;
	results: Array<IStandConversationMessage>;
}

const CONVERSATION_URL: string = '/api/layout/conversation/';

@Injectable({
	providedIn: 'root'
})
export class LayoutService {
	readNotificationSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

	constructor(
		private http: HttpClient,
		private httpService: HttpService
	) {}

	getMessages(planogramId: number, page: number = 1): Promise<ILayoutConversation> {
		return this.httpService.getPromise<ILayoutConversation>(
			this.http.get<ILayoutConversation>(CONVERSATION_URL, {
				params: new HttpParams({
					fromObject: {
						stand: planogramId,
						page: page
					}
				})
			})
		);
	}

	getNotificationStandById(notificationId: number, planogramId: number, planId: number): Promise<any> {
		return this.httpService.getPromise<any>(
			this.http.get<any>(`/api/layout/stands/${planogramId}/?notification=${notificationId}&planogram_id=${planId}&version=2`)
		);
	}

	getUsers(): Promise<Array<IChatUser>> {
		return this.httpService.getPromise<Array<IChatUser>>(
			this.http.get<Array<IChatUser>>('/api/v1/users/')
		);
	}

	bulkSendRotationMessages(data: Array<any>): Observable<ILayoutConversation> {
		return this.http.post<ILayoutConversation>(`${CONVERSATION_URL}bulk-create/`, data);
	}

	updateMessageStatus(id: number, data: { done?: boolean; read?: boolean }): Promise<void> {
		return this.httpService.getPromise<void>(
			this.http.patch<void>(CONVERSATION_URL + `${id}/`, data)
		);
	}

	uploadFile(fd: FormData): Promise<any> {
		return this.httpService.getPromise<any>(
			this.http.post<any>('/api/layout/storages/', fd)
		);
	}

	updateFileName(id: number, name: string): Promise<void> {
		return this.httpService.getPromise<void>(
			this.http.patch<void>(`/api/layout/storages/${id}/`, { name })
		);
	}
}
